const SAVE_PASSWORD = 'SAVE_PASSWORD'
const FORGET_PASSWORD = 'FORGET_PASSWORD'

const state = {
  savedPassword: sessionStorage.getItem('pwd') || ''
}
const getters = {}

const mutations = {
  [SAVE_PASSWORD] (state, data) {
    state.savedPassword = data;
    sessionStorage.setItem('pwd', data)
  },
  [FORGET_PASSWORD] (state) {
    state.savedPassword = null;
    sessionStorage.removeItem('pwd');
  }
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}